export default {
    id: "4e33ae1e-62bd-4086-882d-20a248747121",
    icon: "mdi-cards-diamond",
    name: "shapeDiamond",
    title: "Shape Diamond",
    description: "A block diamond",
}